import { SITE } from '@/app/constants';
import type { SiteType } from '@/app/types';
import type { MedalConfig, MedalType } from './types';

/**
 * 勋章配置
 */
export const MEDAL_CONFIGS: Partial<Record<MedalType, MedalConfig>> = {
  // 宗门大战活动勋章
  zongmen_mvp: {
    icon: 'https://image01.vidu.zone/vidu/media-asset/sect_war_mvp-a1ec986d.svg',
    displayType: 'special',
  },
  zongmen_winner: {
    icon: 'https://image01.vidu.zone/vidu/media-asset/sect_war_winner-1229c339.svg',
    displayType: 'special',
  },
  zongmen_duocan_participant: {
    icon: 'https://image01.vidu.zone/vidu/media-asset/sect_war_duocan-47cc195a.svg',
    displayType: 'special',
  },
  zongmen_shouwei_participant: {
    icon: 'https://image01.vidu.zone/vidu/media-asset/sect_war_shouwei-77189198.svg',
    displayType: 'special',
  },

  // 周年庆活动勋章
  anniversary_voyager: {
    icon:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_voyager-abbd1019.svg'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_voyager-abbd1019.svg',
    video:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_voyager-a5741f47.mp4'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_voyager-a5741f47.mp4',
    poster:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_voyager_poster-e8003a8e.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_voyager_poster-e8003a8e.webp',
    nameClassName: 'bg-[linear-gradient(99deg,#92B2C9_-0.18%,#FFF_29.24%,#95B1C5_58.79%,#FFF_102.33%)]',
    displayType: 'standard',
  },
  anniversary_pro: {
    icon:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_pro-8161e2bc.svg'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_pro-8161e2bc.svg',
    video:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_pro-b113af51.mp4'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_pro-b113af51.mp4',
    poster:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_pro_poster-d1a72c03.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_pro_poster-d1a72c03.webp',
    nameClassName: 'bg-[linear-gradient(99deg,#C9C292_-0.18%,#FFF_29.24%,#C5BA95_58.79%,#FFF_102.33%)]',
    displayType: 'standard',
  },

  // 艺术家勋章
  artist_cpp: {
    icon:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_cpp-f0e5519b.svg'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_cpp-f0e5519b.svg',
    downloadable: true,
    nameClassName: 'bg-[linear-gradient(99deg,#92B2C9_-0.18%,#FFF_29.24%,#95B1C5_58.79%,#FFF_102.33%)]',
    displayType: 'standard',
    video:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_cpp-23afd566.mp4'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_cpp-23afd566.mp4',
    poster:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_cpp-b8425f6d.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_cpp-b8425f6d.webp',
  },
  artist_mentor: {
    icon:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_mentor-d6573f2d.svg'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_mentor-d6573f2d.svg',
    downloadable: true,
    nameClassName: 'bg-[linear-gradient(99deg,#92B2C9_-0.18%,#FFF_29.24%,#95B1C5_58.79%,#FFF_102.33%)]',
    displayType: 'standard',
    video:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_mentor-e4071773.mp4'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_mentor-e4071773.mp4',
    poster:
      SITE === 'china'
        ? 'https://image01.vidu.zone/vidu/media-asset/artist_mentor-cb40e1fa.webp'
        : 'https://image01.cf.vidu.studio/vidu/media-asset/artist_mentor-cb40e1fa.webp',
  },
};

/**
 * 标准展示形式的背景图
 */
export const MEDAL_VIDEO_BG_URL =
  SITE === 'china'
    ? 'https://image01.vidu.zone/vidu/media-asset/anniversary_medal_bg-e336b4b4.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/anniversary_medal_bg-e336b4b4.webp';

export const MEDAL_SIZE_CONFIG = {
  small: 'size-4',
  medium: 'size-5',
  large: 'size-6',
} as const;

export const ARTIST_POSTER_BG_URL: Partial<Record<MedalType, Record<SiteType, string>>> = {
  artist_cpp: {
    china: 'https://image01.vidu.zone/vidu/media-asset/artist_cpp_bg-e3613060.png',
    global: 'https://image01.cf.vidu.studio/vidu/media-asset/artist_cpp_bg_global-6a7525da.png',
  },
  artist_mentor: {
    china: 'https://image01.vidu.zone/vidu/media-asset/artist_mentor_bg-302651b1.png',
    global: 'https://image01.cf.vidu.studio/vidu/media-asset/artist_mentor_bg_global-765c4e6a.png',
  },
};
